import AvgTimeInDaysByOwner from './AvgTimeInDaysByOwner.container';

export default AvgTimeInDaysByOwner;
